import { action, observable } from 'mobx';
import { dispatch } from 'rfx-core';
import _ from 'lodash';
import { IShift } from '@shiftsmartinc/shiftsmart-types';

import { getChildLogger } from '#/shared/utils/client.logger';

export default class ActivateShiftModal {
  log = getChildLogger('ui.ActivateShiftModal');

  @observable
  isOpen = false;

  @observable
  isLoading = false;

  shift = observable.object<Partial<IShift>>({});

  @observable
  error = null;

  @action
  async setup({ shift = {}, open = this.isOpen }) {
    this.set('shift', shift);
    this.open(open);
    this.set('isLoading', false);
  }

  @action
  async activate() {
    const shift = this.shift;
    if (_.isEmpty(shift)) {
      this.log.warn('No shift specified. Cannot activate empty shift obj.');
    }

    const data = {
      status: 'Active',
      uuid: shift.uuid,
    };

    dispatch('ui.loadingModal.open', { message: 'Activating' });
    try {
      await dispatch(`${shift.__t || shift.dataType || 'shift'}s.update`, {
        data,
      });

      dispatch('ui.activateShiftModal.clear');
    } catch (err) {
      this.log.error(err);
      this.log.error('Failed to activate shift: ', shift);

      this.setError(err.message);
    }
    dispatch('ui.loadingModal.close');
  }

  @action
  clear(args = {}) {
    this.isOpen = !!args.open;
    this.isLoading = false;
    this.shift = {};
    this.error = null;
  }

  /** @deprecated Create explicit setter action for each property instead */
  @action
  set(key, value) {
    _.set(this, key, value);
  }

  @action
  open(arg = !this.isOpen) {
    this.isOpen = !!arg;
  }

  @action
  setError(error) {
    this.error = error;
  }
}
